import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CompsTableHeader from '../comps_table_header';

import { changeLeasePage, changeLeaseSort } from '../store/actions/query';
import { retrieveLeases } from '../store/actions/search';
import { setLeaseColumns } from '../store/actions/session';

export class LeasesTableHeader extends React.Component {
  static propTypes = {
    changePage: PropTypes.func.isRequired,
    changeSort: PropTypes.func.isRequired,
    retrieveLeases: PropTypes.func.isRequired,
    setLeaseColumns: PropTypes.func.isRequired,
    sort: PropTypes.string,
  };

  handleSortChange = (sortOption) => {
    const { changePage, changeSort, retrieveLeases } = this.props;

    changeSort(sortOption);
    changePage(1);
    retrieveLeases();
  }

  render() {
    const { sort } = this.props;
    return (
      <CompsTableHeader
        compType="lease"
        setColumns={this.props.setLeaseColumns}
        sort={sort}
        onSortChange={this.handleSortChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  sort: state.query.leaseSort
});

const mapDispatchToProps = {
  retrieveLeases,
  setLeaseColumns,

  changePage: changeLeasePage,
  changeSort: changeLeaseSort,
};

export default connect(mapStateToProps, mapDispatchToProps)(LeasesTableHeader);
